import React from "react" ;
import {PrivateMessagingMenuTitles, SafeguardingFilters,} from "root/DataFunctions/Constants";
import {useLocation} from "react-router-dom";

const PrivateMessagingAppBodyHeader = (props) =>
{
    const {pathname} = useLocation();

    const displayHeader = () =>
    {
        if (pathname.includes(SafeguardingFilters.MISUSE))
        {
            return <h4 className="title">{PrivateMessagingMenuTitles.DEFAULT}</h4>
        }
        else
        {
            return <h4 className="title">{PrivateMessagingMenuTitles.DEFAULT}</h4>
        }
    }

    return (
        <div className="dt-module__header d-none d-md-flex">

            <div className="child-menu-item">
                {displayHeader()}
            </div>

        </div>
    );
}

export default PrivateMessagingAppBodyHeader;
